import image1 from '../../../assets/images/ecommerce/jpg/7.jpg';
import image2 from '../../../assets/images/ecommerce/jpg/8.jpg';
import image3 from '../../../assets/images/ecommerce/jpg/9.jpg';
import image4 from '../../../assets/images/ecommerce/jpg/10.jpg';
import image5 from '../../../assets/images/ecommerce/jpg/11.jpg';
import image6 from '../../../assets/images/ecommerce/jpg/12.jpg';
import image7 from '../../../assets/images/ecommerce/jpg/13.jpg';
import image8 from '../../../assets/images/ecommerce/jpg/14.jpg';
import image9 from '../../../assets/images/ecommerce/jpg/15.jpg';

export const Productdata1 = [
    { id: 1, category: 'planters', title: 'Flower Pot', price: '$25', prevPrice: '$47', imageSrc: image1, isFavorite: true, },
    { id: 2, category: 'Furniture', title: 'Fabric Armchair', price: '$56', prevPrice: '$79', imageSrc: image2, isFavorite: false, },
    { id: 3, category: 'Furniture', title: 'Chair', price: '$39', prevPrice: null, imageSrc: image3, isFavorite: false, },
    { id: 4, category: 'Clothing', title: 'Womens Casual dress', price: '$25', prevPrice: null, imageSrc: image4, isFavorite: false, },
    { id: 5, category: 'Kitchen & Dining', title: 'Coffee Cup', price: '$41', prevPrice: null, imageSrc: image5, isFavorite: true, },
    { id: 6, category: 'Electronics', title: 'Mens Watch', price: '$69', prevPrice: '$97', imageSrc: image6, isFavorite: false, },
    { id: 7, category: 'planters', title: 'Cactus Plant', price: '$39', prevPrice: '$59', imageSrc: image7, isFavorite: true, },
    { id: 8, category: 'Accessories', title: 'Stylish College Bag', price: '$45', prevPrice: '$674', imageSrc: image8, isFavorite: false, },
    { id: 9, category: 'Clothing', title: 'Casual T-shirt', price: '$32', prevPrice: null, imageSrc: image9, isFavorite: false, },
]
//Category
export const Category = [
    { id: 1, label: 'Foot wear', checked: true },
    { id: 2, label: 'Top wear', checked: false },
    { id: 3, label: 'Bottom wear', checked: false },
    { id: 4, label: 'Accessories', checked: true },
    { id: 5, label: 'Furniture', checked: false },
    { id: 6, label: 'Electronics', checked: true },
]